// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { featureIsEnabled } from '@ta/common.features';
import ContentCollection from '@ta/brand.global-nav-action-content-collect';
import ShoppingCart from '@ta/brand.global-nav-action-shopping-cart';
import Trips from '@ta/brand.global-nav-action-trips';
import InboxTrigger from '@ta/brand.global-nav-action-inbox';
import { Profile } from '@ta/brand.global-nav-action-profile';
import { t4bNavPages } from './T4BNav';
import styles from './GlobalNavActions.less';

type ExternalProps = {|
  /** Whether we show a very simple header with just the logo and search icon. */
  liteHeader: boolean,
|};

type Props = {|
  ...ExternalProps,

  /** Whether user is logged in. */
  isLoggedIn: boolean,

  /** Whether we're in read-only mode. */
  readOnlyMode: boolean,

  /** Whether the viewport category is mobile. */
  isMobile: boolean,

  /** Extra predicates to determine if the shopping cart should show. False hides the cart action. */
  extraShoppingCartPredicates: boolean,

  /** Determine if this page is a T4B page */
  extraContentCollectionPredicates: boolean,
|};

/** Container for all of the global nav actions (i.e. cart, trips, profile) */
const globalNavActions = (props: Props) => {
  const isAddGlobalNavCTA =
    !props.extraContentCollectionPredicates && featureIsEnabled('add_cta_to_global_nav');

  return (
    <React.Fragment>
      {!props.liteHeader && (
        <React.Fragment>
          {/* ShoppingCart has a render prop for its contents because internally it conditionally shows, and we don't want to show a random separator if it's hidden. */}
          {featureIsEnabled('shopping_cart_desktop') && props.extraShoppingCartPredicates && (
            <ShoppingCart>
              {contents =>
                contents && (
                  <React.Fragment>
                    <div className={styles.navAction}>{contents}</div>
                  </React.Fragment>
                )
              }
            </ShoppingCart>
          )}

          {isAddGlobalNavCTA && (
            <div className={`${styles.navAction} ${styles.hiddenOnMobile}`}>
              {<ContentCollection />}
            </div>
          )}

          {(featureIsEnabled('saves') || featureIsEnabled('trips_2018')) && !props.isMobile && (
            <React.Fragment>
              <div className={styles.navAction}>
                <Trips />
              </div>
            </React.Fragment>
          )}
          {!props.readOnlyMode && featureIsEnabled('unified_inbox_v2') && (
            <div className={`${styles.navAction} ${styles.hiddenOnMobile}`}>
              <InboxTrigger />
            </div>
          )}
          <div className={`${styles.navAction} ${styles.hiddenOnMobile}`}>
            <Profile />
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default connect<Props, ExternalProps, _, _, _, _>(state => ({
  isLoggedIn: state.auth.isMember,
  readOnlyMode: state.meta.readOnlyMode,
  isMobile: state.meta.device.viewportCategory === 'MOBILE',
  extraShoppingCartPredicates: ![
    'ShowUserReviews',
    'ShowUserReviewsHotels',
    'ShowUserReviewsRestaurants',
    'ShowUserReviewsAttractions',
    'MobileShowUserReviews',
  ].includes(state.route.page),
  extraContentCollectionPredicates: t4bNavPages.includes(state.route.page),
}))(globalNavActions);
